import CommonLogin from '../../../common/pages/public/Login'

class Login extends CommonLogin {
  constructor (props) {
    super(props)
    this.state = {email: '', password: '', redirectTo: ''}
    this.loginFormTitle = '日本型枠工事業協会 [企業管理者]'
    this.userRoleUrl = 'company_admin'
    this.userRole = 'companyAdmin'
  }
}

export default Login



// WEBPACK FOOTER //
// ./src/company_admin/pages/public/Login.js